/*
 *
 * Package: `@dbh/philosophy-and-benefits-page`.
 *
 */const importPhilosophyAndBenefitsPage=()=>import('./component-7b6e0fbc.js'/*  webpackChunkName: 'dbh.philosophy-and-benefits-page.component' */);// to avoid the exported code leaking into other pages and increasing the bundle
// size unappropriately.

export { importPhilosophyAndBenefitsPage as default };
